import {Pipe, PipeTransform} from '@angular/core';
import {ProjectReferenceStatus, referenceStatusTranslation} from '../models/project-reference';

@Pipe({
    name: 'statusTranslate',
    standalone: false
})
export class StatusTranslatePipe implements PipeTransform {

    transform(value: ProjectReferenceStatus): string {
        return referenceStatusTranslation[value];
    }

}
